// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__(2470)))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor"], () => (__webpack_require__(9994)))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
